import { render, staticRenderFns } from "./NavMenuItemRenderer.vue?vue&type=template&id=4aa87ffa&scoped=true"
import script from "./NavMenuItemRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./NavMenuItemRenderer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NavMenuItemRenderer.vue?vue&type=style&index=0&id=4aa87ffa&prod&lang=less&scoped=true"
import style1 from "./NavMenuItemRenderer.vue?vue&type=style&index=1&id=4aa87ffa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa87ffa",
  null
  
)

export default component.exports